import { render, staticRenderFns } from "./AssetCardWidgetComponent.vue?vue&type=template&id=badce0c8&"
import script from "./AssetCardWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./AssetCardWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports